import(/* webpackMode: "eager" */ "/codebuild/output/src3569558602/src/doctor-dashboard/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3569558602/src/doctor-dashboard/src/components/loader/SplashScreenLoader.tsx");
